﻿import intlTelInput from "intl-tel-input";
import {get} from '@/Utils';
import {validatePhoneNumber} from '@/Validation';

function initPhone(element: HTMLElement, country: string) {
    if (element.hasAttribute("data-bound")) return
    element.setAttribute("data-bound", "")
    return intlTelInput(element as HTMLInputElement, {
        initialCountry: country,
        nationalMode: false,
        formatOnDisplay: false,
        onlyCountries: ["ee", "lv", "lt", "fi"],
        autoPlaceholder: "off",
        // @ts-ignore
        loadUtilsOnInit: () => import("intl-tel-input/build/js/utils.js")
    });
}
window.initPhoneInput = initPhone;
export function getPhoneInstanceAndInitIfNotExists(input: HTMLInputElement){
    let iti = intlTelInput.getInstance(input)
    if(iti){
        return iti;
    }
    iti = initPhone(input, (get("country-code") as HTMLInputElement).value)
    if (iti){
        iti.promise.then(() => {
            input.value = iti.getNumber()
        })
        input.addEventListener("countrychange", () => {
            validatePhoneNumber(input, iti)
        })
        input.addEventListener("input", () => {
            validatePhoneNumber(input, iti)
        })
        input.addEventListener("focus", () => {
            if (!input.value) {
                input.value = `+${iti.getSelectedCountryData().dialCode}`
            }
        })
    }
    return intlTelInput.getInstance(input)
}